export const darkTealPinkTheme = {
  palette: {
    mode: "dark",
    // === Primary Background Variants ===
    primaryBG: {
      live: "",
      700: "#101211", // main background
      650: "#0A2024",
      625: "#0A2024",
      600: "#12494E",
      550: "#12494E",
      500: "#12494E",
      450: "#0A2024",
      400: "#0A2024",
      380: "#0A2024",
      350: "#0A2024",
      300: "#12494E",
      250: "#0A2024",
      200: "#0A2024",
      white: "#ffffff"
    },

    // === Secondary Background ===
    secondaryBG: {
      main: "#2F7379",
      red: "#0A2024"
    },

    // === Primary Text Colors ===
    primaryText: {
      800: "#CCCCCC",
      400: "#BBBBBB",
      300: "#999999",
      250: "#777777",
      200: "#666666",
      100: "#FFFFFF"
    },

    // === Secondary Text Colors ===
    secondaryText: {
      700: "#ffffff",
      650: "#0A2024",
      625: "#0A2024",
      600: "#12494E",
      550: "#12494E",
      500: "#12494E",
      450: "#2F7379",
      400: "#2F7379",
      350: "#0A2024",
      300: "#12494E",
      250: "#2F7379",
      200: "#2F7379"
    },

    // === Support Chat / Scroll ===
    supportChatText: {
      border: "#545050",
      main: "#434352"
    },
    scroll: {
      350: "#434352",
      track: "#12494E"
    },

    // === My Bet Buttons ===
    myBetBtnBG: {
      700: "#ABABAB",
      600: "#949494",
      500: "#0A2024", // CTA pink
      400: "#2F7379", // teal secondary
      300: "#00FF66", // neon green outcome
      getCashoutBtn: "#0A2024"
    },
    myBetBtnText: "#fff",

    // === Highlights / Outcomes ===
    resultHighlightOutcome: "#00FF66",
    topMatchLive: "linear-gradient(90deg, #0A2024 0%, #2F7379 100%)",
    betSlipGreadient: "linear-gradient(90deg, #12494E 4.63%, #2F7379 94.29%)",

    primary2TextColor: {
      main: "#FF014D"
    },

    betHistory: {
      primaryBG: "#0A2024",
      secondaryBG: "#12494E",
      secondarycolor: "#12494E",
      optionBG: "#2F7379"
    },

    textFieldBorder: "#2F7379",

    activeFavBG: {
      main: "#2F7379"
    },

    casinoSearch: {
      inputBG: "#12494E",
      categoryBG: "#0A2024",
      primaryBG: "#2F7379"
    },

    scoreHeader: {
      main: "#67627b"
    },

    nomatches: "#574264",

    betGradient: {
      main: "linear-gradient(90deg, #0A2024 0.21%, #2F7379 100.21%)",
      before: "linear-gradient(90deg, #0A2024 2.73%, #2F7379 96.68%)"
    },

    betSlipErrMsg: "#0A2024",

    appHeaderButtonBG: {
      active: "#FF014D",
      main: "#0A2024",
      red: "#0A2024"
    },
    appHeaderText: {
      main: "#FFFFFF",
      active: "#0A2024"
    },

    sportbookSearchBtn: {
      bg: "#0A2024",
      text: "#FFFFFF",
      hoverBg: "#2F7379",
      hoverText: "#FFFFFF"
    },

    homeborderGradient: "linear-gradient(180deg, #0A2024 0%, #0A2024 100%)"
  },

  overrides: {
    MuiCssBaseline: {
      "@global": {
        "*::-webkit-scrollbar": {
          width: "0.4em"
        },
        "*::-webkit-scrollbar-track": {
          "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)"
        },
        "*::-webkit-scrollbar-thumb": {
          backgroundColor: "#2F7379",
          borderRadius: 10
        }
      }
    },
    MuiList: {},
    MuiTabs: {
      flexContainer: {
        justifyContent: "flex-start",
        alignItems: "center",
        display: "flex",
        "@media (max-width: 991px)": {
          justifyContent: "flex-start"
        }
      }
    },
    MuiContainer: {},
    MuiTableCell: {}
  },

  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& fieldset": {
            borderColor: "#2F7379 !important"
          }
        }
      }
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: "#12494E"
        }
      }
    },
    MuiCalendarPicker: {
      styleOverrides: {
        root: {
          "& .MuiPickersDay-root": {
            backgroundColor: "#0A2024",
            color: "#fff"
          },
          "& .MuiPickersDay-root.Mui-selected": {
            backgroundColor: "#0A2024 !important",
            color: "#fff",
            fontWeight: 700
          },
          "& .MuiPickersDay-root:hover": {
            backgroundColor: "#2F7379",
            color: "#fff"
          }
        }
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          background:
            "linear-gradient(to right, rgba(23,38,41,1) 1%, rgba(24,25,24,1) 99%)"
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          minWidth: "auto"
        }
      }
    }
  },

  typography: {
    fontFamily: "Poppins"
  }
};
